import { OPPORTUNITIES } from "../configs/routes.js";
import { isNicheId } from "../constants/niches.js";
import api from "./api.js";

/**
 * Build query params for GET /opportunities/
 * - Default (no source_type): global + user industry/category, newest first
 * - source_type=global: global only
 * - source_type=industry: industry only
 * - niche=<niche-id>: opportunities for a niche landing page
 * - sort=relevance: relevance ordering (any source / niche)
 */
export function buildOpportunitiesQueryParams({
    limit,
    last_doc_id,
    search,
    start_date,
    end_date,
    sourceType,
    source_type,
    sort,
    niche,
    ...rest
} = {}) {
    const params = { ...rest };

    if (limit != null) params.limit = limit;
    if (last_doc_id) params.last_doc_id = last_doc_id;
    if (search?.trim()) params.search = search.trim();
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;

    const scope = sourceType ?? source_type;

    if (scope === "global") {
        params.source_type = "global";
    } else if (scope === "industry") {
        params.source_type = "industry";
    }

    if (niche && isNicheId(niche)) {
        params.niche = niche;
    }

    if (sort === "relevance" || sort === "relevance_desc") {
        params.sort = "relevance";
    }

    return params;
}

export const getOpportunities = (params = {}) =>
    new Promise((resolve, reject) => {
        api
            .get(OPPORTUNITIES, {
                params: buildOpportunitiesQueryParams(params),
                timeout: 60000,
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });
